<template>
    <CardPage :section="13" :page="8">
        <div>
            <p>
                Let’s review the positive and negative aspects of the relationship:
            </p>
            <v-card class="mb-1">
                <v-card-title class="pb-0">
                    <span class="title success--text">Positive</span>
                    <v-spacer></v-spacer>
                    <v-icon class="success--text">thumb_up</v-icon>
                </v-card-title>
                <v-card-text>
                    <ul>
                        <li v-for="(item, index) in positives" :key="index">{{ item.text }}</li>
                    </ul>
                </v-card-text>
            </v-card>
            <v-card class="mb-1">
                <v-card-title class="pb-0">
                    <span class="title error--text">Negative</span>
                    <v-spacer></v-spacer>
                    <v-icon class="error--text">thumb_down</v-icon>
                </v-card-title>
                <v-card-text>
                    <ul>
                        <li v-for="(item, index) in negatives" :key="index">{{ item.text }}</li>
                    </ul>
                </v-card-text>
            </v-card>
        </div>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';
import { filter, values } from 'lodash';

export default {
    computed: {
        quiz: get('section13/quiz'),
        positives() {
            return filter(values(this.quiz), { correctAnswer: 'positive' });
        },
        negatives() {
            return filter(values(this.quiz), { correctAnswer: 'negative' });
        }
    }
};
</script>
